import 'Glonass/UI/Workspace'
import './MenuForm'

/** @namespace Agronomy.UI */
NS('Agronomy.UI')

/**
 * @class
 * @extends Glonass.UI.Workspace
 */
Agronomy.UI.Workspace = Class(Glonass.UI.Workspace, /** @lends Agronomy.UI.Workspace.prototype */{
    template: 'Agronomy/Workspace',
    menuFormClass: 'Agronomy.UI.MenuForm',

    addItems () {
        this.addItem('map', () => import('./MapForm'))
            .addItem('cabinet', () => import('./Cabinet/CabinetForm'))
            .addItem('spatial', () => import('Spatial/UI/MainForm'))
            .addItem('spatialMeta', () => import('SpatialMeta/UI/MainForm'))
            .addItem('settings', () => import('./AdminForm'))
            .addItem('reports', () => import('./ReportsForm'))
            .addItem('accounting', () => import('Accounting/UI/MainForm'))

        return this
    },

    render () {
        this.Call(...['UI.Widget.Base', ...arguments])

        this.$workspace = this.$name('workspace', true)

        this.showItem('cabinet')

        return this
    },

    async showMenu () {
        return this.ParentCall(() => this.closeAll(['map', 'admin.menu']))
    },

    async showItem (name, options) {
        return this.ParentCall(name, options).then(() => this.closeAll(['map', name]))
    },
})
